import { useQuery } from '@tanstack/react-query'
import { listBlocks, listPendingBlocks } from '../api'
import type { ListArgs } from '../api'

export const blocksListQueryKey = (args: ListArgs) =>
  ['blocks', 'list', args] as const

export function useBlocks(args: ListArgs = {}) {
  return useQuery({
    queryKey: blocksListQueryKey(args),
    queryFn: () => listBlocks(args),
    staleTime: 15_000,
  })
}

export const pendingBlocksQueryKey = ['blocks', 'pending'] as const

/**
 * Pending-blocks query — drives both the ApprovalQueue page and the
 * sidebar count badge. Polls every 30s as a safety net for missed WS events.
 */
export function usePendingBlocks() {
  return useQuery({
    queryKey: pendingBlocksQueryKey,
    queryFn: listPendingBlocks,
    staleTime: 10_000,
    refetchInterval: 30_000,
  })
}
